const PROFILE_LOGS_DOMAIN = 'profileLogs'

export { PROFILE_LOGS_DOMAIN }
